import { useState, useEffect } from 'react';
import { CustomPaymentTypesApi } from '@/api/clients/custom-payments/custom-payment-types.api';

export const useGetAutoFillVariables = (enabled = true) => {
  const [variables, setVariables] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    const fetchVariables = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data } = await CustomPaymentTypesApi.getAutoFillVariables();
        if (!cancelled) {
          setVariables(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        if (!cancelled) {
          const errorMessage =
            err.response?.data?.message ||
            'Failed to fetch auto-fill variables';
          setError(errorMessage);
          console.error('Error fetching auto-fill variables:', err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchVariables();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { variables, loading, error };
};
